import axios from 'axios';
import Cookies from 'js-cookie';

import { getCloudFunctionUrl } from '../config/api.config';

export function verifyFirebaseAccess(environment) {
  const rampartToken = Cookies.get('rampart_token');
  const cloudFunctionUrl = getCloudFunctionUrl(environment)

  if (rampartToken) {
    return axios.get(cloudFunctionUrl, {
      'headers': {
        'Authorization': rampartToken
      }
    })
  } else {
    return Promise.reject('Unauthorised user');
  }
}